(function () {

    'use strict';

    angular.module('iplusjs.alert.component', [
        'lodash'
    ])
        .component('iplusjsAlert', {
            templateUrl: 'common/alert/alert.html',
            bindings: {
                type: '@',
                hideOnClose: '@',
                hideOnTime: '@',
                close: '&?'
            },
            transclude: true,
            controller: AlertController,
            controllerAs: 'alertVm'
        });

    AlertController.$inject = [
        '$scope',
        '$element',
        '$animate',
        '$timeout',
        'lodash'
    ];
    function AlertController($scope, $element, $animate, $timeout, _) {
        var vm = this;

        vm.$onInit = onInit;

        vm.onClose = onClose;

        function activate() {
            $animate.enabled($element, false);

            $timeout(function () {
                $animate.enabled($element, true);
            });

            vm.visible = true;
            vm.closeable = angular.isFunction(vm.close);
            vm.timeout = parseInt(vm.hideOnTime, 10);
            vm.hideOnClose = $scope.$eval(vm.hideOnClose);

            if (_.isInteger(vm.timeout)) {
                vm.hideOnClose = true;

                $timeout(function () {
                    onClose();
                }, vm.timeout);
            }
        }

        function onInit() {
            activate();
        }

        function onClose() {
            if (vm.hideOnClose) {
                vm.visible = false;
            }

            if (vm.closeable && angular.isFunction(vm.close)) {
                if (_.isInteger(vm.timeout)) {
                    $timeout(function () {
                        vm.close();
                    }, 750);
                } else {
                    vm.close();
                }
            }
        }
    }
})();
